import { MiaPlaza } from "@/Reinforced.Typings";
import { Options } from "intro.js/src/option";
import { VNode } from "vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import { useModule } from "vuex-simple";
import MiaTourModule from "../Vuex/MiaTourModule";
import { waitForPageReadiness } from "@/utils/PageReadinessDetector";

/**
 * This component manages the lifecycle of a mia tour using the `MiaTourModule` Vuex module.
 * It initializes a tour upon checking page readiness and ensures the tour is properly cleaned up before the component is destroyed.
 * The `tour` prop specifies the tour to load, while optional configuration can be passed through the `options` prop.
 */
@Component
export default class MiaTour extends Vue {
	@Prop({ required: true, type: String }) protected tour!: MiaPlaza.Model.MiaTour.Tour;
	@Prop({ required: false, type: Object }) protected options?: Partial<Options>;

	destroyed = false;

	async mounted(): Promise<void> {
		await waitForPageReadiness({ stabilityDuration: 600 });

		if (!this.destroyed) {
			this.miaTourModule.InitializeTour(this.tour, this.options);
		}
	}

	beforeDestroy(): void {
		this.destroyed = true;
		this.miaTourModule.DestroyTour(this.tour);
	}

	private get miaTourModule(): MiaTourModule {
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		return useModule<MiaTourModule>(this.$store, [MiaPlaza.Control.Vue.MiaTourModuleRegistration.MODULE])!;
	}

	/**
	 * A render function is required when a Vue component lacks a `<template>`. 
	 * Since this is a logical component with no rendered DOM elements, we return `undefined` 
	 * to prevent errors or warnings. 
	 */
	protected render(): VNode[] | undefined {
		return undefined;
	}
}
